export default __webpack_public_path__ + "static/media/Nature.ae7c02d2.jpg";